import { render, staticRenderFns } from "./BiometricSuccess.vue?vue&type=template&id=142dc76e&scoped=true"
import script from "./BiometricSuccess.vue?vue&type=script&lang=js"
export * from "./BiometricSuccess.vue?vue&type=script&lang=js"
import style0 from "./BiometricSuccess.vue?vue&type=style&index=0&id=142dc76e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142dc76e",
  null
  
)

export default component.exports